/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Subject_Kind_TeamInputs */



/**
* | output |
* | --- |
* | "Team" |
*
* @param {Rights_Subject_Kind_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_subject_kind_team = /** @type {((inputs?: Rights_Subject_Kind_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Subject_Kind_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team")
	return /** @type {LocalizedString} */ ("Team")
});